import { render, staticRenderFns } from "./shipItem.vue?vue&type=template&id=28ea6ebf&scoped=true"
import script from "./shipItem.vue?vue&type=script&lang=js"
export * from "./shipItem.vue?vue&type=script&lang=js"
import style0 from "./shipItem.vue?vue&type=style&index=0&id=28ea6ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea6ebf",
  null
  
)

export default component.exports